import { Artifact } from '@models/note';
import { format } from 'date-fns';
import { NoteType } from '@lio/rule-engine';
import { noteQueryKey } from '@services/note/keys';

export const searchNoteParams = {
  type: NoteType.Note,
  pageLimit: 10,
  sort: '-createdAtOrReplacedAt,-createdAt',
};

export const searchMessageParams = {
  type: NoteType.Message,
  pageLimit: 10,
  sort: '-createdAt',
};
export const getNoteMessagesParams = (quoteId: string, type: NoteType) =>
  noteQueryKey.searchWithParams({
    quoteId,
    ...(type === NoteType.Note ? { ...searchNoteParams } : { ...searchMessageParams }),
  });

// TODO: replace dmsUrl for file name
export const getFilterText = (note: { body: string; createdAtOrReplacedAt: string; artifacts: Artifact[] }) => {
  const { body, createdAtOrReplacedAt, artifacts } = note;
  return `${[body, format(new Date(createdAtOrReplacedAt), 'HH:MM:ss zzz MMM dd, yyyy'), createdAtOrReplacedAt]
    .filter(Boolean)
    .join('__')}__${artifacts?.map((a) => [a.description, a.source!.dmsUrl].filter(Boolean).join('_'))}`;
};
